import { defineSectionEvents } from '../utils';

export const MAIN_TOOLBAR_EVENTS = defineSectionEvents(
  'Main Toolbar',
  'Actions',
  {
    TOOLBAR_ADD_DEAL_CLICKED: {
      action: 'Add Deal Clicked',
      description: 'User clicked the "Add Deal" button in the toolbar.',
    },

    TOOLBAR_AI_CHAT_TOGGLED: {
      action: 'AI Chat Opened',
      description: 'User opened the AI chat panel via the toolbar button.',
    },

    TOOLBAR_TASKS_PANEL_TOGGLED: {
      action: 'Tasks Panel Opened',
      description: 'User opened the tasks panel via the toolbar button.',
    },

    TOOLBAR_ADD_CONTACT_CLICKED: {
      action: 'Add Contact Clicked',
      description: 'User clicked the "Add Contact" button in the toolbar.',
    },

    TOOLBAR_ADD_NOTE_CLICKED: {
      action: 'Add Note Clicked',
      description: 'User clicked the "Add Note" button in the toolbar.',
    },
  }
);
